<template>
    <mm-tab-title v-model="tab" :titles="titles" ref="advSummaryEditRef">
        <el-button v-show="tab===1" slot="save" size="medium" type="primary" @click="submit">save</el-button>
        <div>
            <div v-show="tab===1">

        <el-form ref="form" :model="result" size="small" label-width="200px">
                <el-form-item label="Period" >
                    <el-input :value="result.period" readonly />
                </el-form-item>
                <el-form-item label="Adv Name" >
                    <el-input v-model="result.adv_name" readonly />
                </el-form-item>
                <el-form-item label="Revenue" >
                    <el-input :controls="false" v-model="result.snt_rev" readonly />
                </el-form-item>
                <el-form-item label="Advertiser Revenue" >
                    <mm-number-input v-model="result.adv_rev" />
                    <mm-upload v-model="result.adv_rev_file" dir="advSummary"></mm-upload>
                </el-form-item>
                <el-form-item label="Final Revenue" >
                    <mm-number-input v-model="result.confirm_amount" />
                    <mm-upload v-model="result.confirm_amount_file" dir="advSummary"></mm-upload>
                </el-form-item>
                <el-form-item label="Amount Status" >
                    <mm-summary-amount-status v-model="result.amount_status"/>
                </el-form-item>
                <el-form-item label="Receive Amount" v-if="is_show_status">
                    <mm-number-input v-model="result.received_amount"/>
                    <mm-upload v-model="result.received_amount_file" dir="advSummary"></mm-upload>
                </el-form-item>
                <el-form-item label="Status" v-if="is_show_status">
                    <mm-summary-status v-model="result.status"/>
                    <el-date-picker type="date" v-model="result.status_date"/>
                </el-form-item>
                <el-form-item label="Payout Type" >
                    <mm-payout-type-select v-model="result.payout_type" />
                </el-form-item>
                <el-form-item label="Invoice" >
                    <mm-upload v-model="result.invoice_file" dir="advSummary"></mm-upload>
                </el-form-item>
                <el-form-item label="Export PDF" v-if="result.adv_id && is_show_status" >
                    <el-button @click="()=>{monthSelectVisible = true;invoiceType = 'USD'}">Export</el-button>
                    <!-- <el-button @click="()=>{monthSelectVisible = true;invoiceType = 'EUR'}">Export(EUR)</el-button> -->
                </el-form-item>
                <el-form-item label="Send Invoice Email" v-if="result.adv_id" >
                    <el-button @click="sendMailVisible = true">Send</el-button>
                </el-form-item>
                <el-form-item label="Remark" prop="remark"  >
                    <el-input v-model="result.remark" type="textarea" :rows="5" />
                    <mm-upload v-model="result.file" dir="advSummary"></mm-upload>
                </el-form-item>
        </el-form>

            </div>
            <div v-show="tab===2" style="height:700px;">
                <adv-channel-summary :where="{time:result.time,adv_id:result.adv_id}" />
            </div>

        </div>
        <el-dialog
            title="Export PDF Time"
            :visible.sync="monthSelectVisible"
            width="30%"
        >
            <el-form :model="exportForm" size="small" label-width="100px">
                <el-form-item label="Period">
                    <mm-month-picker v-model="exportForm.time" />
                </el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click="getPdfInfo">Submit</el-button>
				</el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog
            title="PDF"
            :visible.sync="pdfVisible"
            width="1280px"
        >
            <invoiceTemplate ref="pdfReviewRef" :invoiceType="invoiceType" :advInfo="advInfo" :exportList="exportList" :nowDate="nowDate" :invoiceNo="invoiceNo"/>
            <el-row style="text-align: right;">
                <el-button @click="exportPDF" :disabled="pdfLoading" type="primary">{{ pdfLoading ? 'loading...' : 'export PDF' }}</el-button>
                <el-button @click="uploadPDF" :disabled="pdfUploadLoading" type="primary">{{ pdfUploadLoading ? 'loading...' : 'upload PDF' }}</el-button>
            </el-row>
        </el-dialog>
        
        <el-dialog
            title="Send Invoice Email"
            :visible.sync="sendMailVisible"
            width="80%"
        >
            <el-form :model="sendMailForm" size="small" label-width="100px">
                <el-form-item label="Emails">
                    <el-input v-model.trim="sendMailForm.emails" />
                </el-form-item>
                <el-form-item label="Title">
                    <el-input v-model.trim="sendMailForm.title" />
                </el-form-item>
                <el-form-item label="Body">
                    <el-input v-model="sendMailForm.body" type="textarea" :rows="6" />
                </el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click="sendMailSubmit" :disabled="sendMailLoading">{{ sendMailLoading ? 'Send...' : 'Submit' }}</el-button>
				</el-form-item>
            </el-form>
        </el-dialog>
    </mm-tab-title>


</template>

<script>
import advChannelSummary from '../components/finance/advChannelMmpSummary'
import invoiceTemplate from '../components/finance/invoiceTemplate'
export default {
	watch:{
		'$route' (to, from) {
			this.loadData();
		}
	},
	data() {
        const monthName = {
            '01': 'Jan',
            '02': 'Feb',
            '03': 'Mar',
            '04': 'Apr',
            '05': 'May',
            '06': 'Jun',
            '07': 'Jul',
            '08': 'Aug',
            '09': 'Sep',
            '10': 'Oct',
            '11': 'Nov',
            '12': 'Dec',
        };
        const dateName = ["1st","2nd","3rd","4th","5th","6th","7th","8th","9th","10th","11th","12th","13th","14th","15th","16th","17th","18th","19th","20th","21st","22nd","23rd","24th","25th","26th","27th","28th","29th","30th","31st"];
        const nowDateArr = this.$utils.date_format(new Date(), 'DD.MM.YYYY').split('.');
        nowDateArr[0] = dateName[Number(nowDateArr[0]) - 1];
        nowDateArr[1] = monthName[nowDateArr[1]];
        const nowDate = nowDateArr.join('.');
        let no = (Math.random() * 100).toFixed(0);
        while(no.length < 3) {
            no = '0' + no;
        }
        const invoiceNo = this.$utils.date_format(new Date(), 'YYYYMMDD') + no;
        const user_info = this.$utils.getCookies(['is_super']);
        const is_show_status = user_info.is_super == '1'; 
		return {
			result: {
                payout_type: 'airwallex'
			},
			file_list:[],
			tab: 1,
			titles:['Summary','Detail'],
            monthSelectVisible: false,
            invoiceType: 'USD',
            exportForm: {},
            exportList: [],
            advInfo: {},
            pdfVisible: false,
            nowDate,
            invoiceNo,
            monthName,
            dateName,
            pdfName: '',
            pdfLoading: false,
            pdfUploadLoading: false,
            sendMailVisible: false,
            sendMailLoading: false,
            sendMailForm: {
                emails: '',
                title: '',
                body: ''
            },
            is_show_status,
		};
	},
    watch: {
        sendMailVisible() {
            if (this.sendMailVisible) {
                let invoiceFile = [];
                if (this.result.invoice_file) {
                    invoiceFile = JSON.parse(this.result.invoice_file);
                }
                if (invoiceFile.length) {
                    this.sendMailForm.file_name = invoiceFile[0].file_name;
                    this.sendMailForm.file_path = invoiceFile[0].file_path;
                    this.sendMailForm.title = `Invoice|${this.result.period}|${this.result.adv_name}|Little9|${this.result.confirm_amount}`;
                    this.sendMailForm.body = invoiceTemplate.data().invoiceObj[this.invoiceType].emailBody.replace('{invoice_name}', this.sendMailForm.title);
                }
            }
        }
    },
	methods: {
		async submit() {
			const request_path ='/advMmpSummary/update';
			const result = await this.$post(request_path,this.result);
			this.loadData();
		},
		async loadData(){
			const id= this.$route.query['id'];
			this.result = await this.$post('/advMmpSummary/detail',{id:id});
            if (!this.result.payout_type) {
                this.result.payout_type = 'airwallex';
            }
            await this.getAdvInfo();
            let invoiceFile = [];
            if (this.result.invoice_file) {
                invoiceFile = JSON.parse(this.result.invoice_file);
            }
            if (invoiceFile.length) {
                this.sendMailForm.file_name = invoiceFile[0].file_name;
                this.sendMailForm.file_path = invoiceFile[0].file_path;
                this.sendMailForm.title = `Invoice|${this.result.period}|${this.result.adv_name}|Little9|${this.result.confirm_amount}`;
                this.sendMailForm.body = invoiceTemplate.data().invoiceObj[this.invoiceType].emailBody.replace('{invoice_name}', this.sendMailForm.title);
            }
		},
        async exportPDF() {
            this.pdfLoading = true;
            await this.getPdf(this.$refs.pdfReviewRef.$el, this.pdfName);
            this.pdfLoading= false;
        },
        async uploadPDF() {
            this.pdfUploadLoading = true;
            const pdf = await this.getPdf(this.$refs.pdfReviewRef.$el, this.pdfName, false);
            const formdata = new FormData();
            formdata.append("dir", 'advSummary');
            formdata.append("file", pdf);
            const res = await this.$post('/file/upload', formdata);
            let invoice_file = [];
            if (this.result.invoice_file) {
                invoice_file = JSON.parse(this.result.invoice_file);
            }
            invoice_file.push(res);
            this.result.invoice_file = JSON.stringify(invoice_file);
            this.pdfVisible = false;
            this.pdfUploadLoading= false;
        },
        async getPdfInfo() {
            // console.log('exportForm',this.exportForm);
            if (!this.exportForm.time) {
                this.$message.error('Missing Period');
                return;
            }
            this.exportList = await this.$post('/advMmpSummary/getConfirmAmount', { time: this.exportForm.time, adv_id: this.result.adv_id})
            let summaryRev = 0;
            const icon = invoiceTemplate.data().invoiceObj[this.invoiceType].icon;
            if (this.exportList.length) {
                this.exportList = this.exportList.map((row) => {
                    row.time = this.$utils.date_format(new Date(row.time * 1000), 'YYYY-MM');
                    row.confirm_amount = row.confirm_amount && row.confirm_amount + icon || `0${icon}`;
                    summaryRev += Number(row.confirm_amount.replace(icon, ''));
                    return row;
                });
                this.exportList.push({
                    time: 'Total Due',
                    confirm_amount: summaryRev + icon
                });
            }
            this.advInfo.billing_info = this.advInfo.billing_info && this.advInfo.billing_info.split(/\n/).map((row) => {
                return '<p>' + row + '</p>';
            }).join('') || '';
            this.monthSelectVisible = false;
            let date = this.result.period.replace('-', '_');
            Object.keys(this.monthName).forEach((num) => {
                date = date.replace(new RegExp(num + '$'), this.monthName[num]);
            })
            this.pdfName = `${this.result.adv_name}_${this.result.period}_${this.result.confirm_amount}_Little9`; 
            this.pdfVisible = true;
        },
        async getAdvInfo() {
			this.advInfo = await this.$post('/advertiser/detail',{adv_id:this.result.adv_id});
            this.sendMailForm.emails = this.advInfo.client_finance_email || '';
        },
        async sendMailSubmit() {
            let invoiceFile = [];
            if (this.result.invoice_file) {
                invoiceFile = JSON.parse(this.result.invoice_file);
            }
            if (!invoiceFile.length) {
                this.$message.error('Miss Invoice File')
                return;
            }
            this.sendMailLoading = true;
            await this.$post('/advMmpSummary/sendInvocieMail', this.sendMailForm).finally(() => {
                this.sendMailLoading = false;
            });
            this.sendMailVisible = false;
        },
	},
    
	beforeMount() {
		this.loadData();
	},
	components:{
		'adv-channel-summary':advChannelSummary,
        invoiceTemplate,
	}
};
</script>
